<template>
  <div>
    <div id="experience" class="row single-info">
      <div align="left">
        <div class="resume-view-header">{{ info.degree_name }} - {{ info.grade }}</div>
        <div class="">{{ info.institution_name }}</div>
        <div class="">{{ info.major_name }}</div>
        <div class="resume-view-details">{{info.education_description}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience-card",
  components: {},
  props: {
    edu: Object,
    index: Number
  },
  data: function() {
    return {
      info: this.edu,
      check: 0,
      overflowed: false,
      truncateView: true
    };
  },
  methods: {
    calculateEllipsesText: function() {
      const self = this;
      const maxLength = 60;
      if (self.work.work_description) {
        let description = self.work.work_description;
        let length = description.length;
        if (length <= maxLength) {
          this.overflowed = false;
          return description;
        } else {
          let line1 = description.substring(0, 60) + "\n";
          let line2, line3;
          if (length / maxLength < 3) {
            this.overflowed = false;
            if (length / maxLength < 2) {
              line2 = description.substring(60, length) + "\n";
              line1 += line2;
            } else {
              line2 = description.substring(60, 120) + "\n";
              line3 = description.substring(120, length) + "\n";
              line1 = line1 + line2 + line3;
            }
          } else {
            this.overflowed = true;
            line2 = description.substring(60, 120) + "\n";
            line3 = description.substring(120, 160) + "\n";
            line1 = line1 + line2 + line3;
          }
          return line1;
        }
      } else {
        return;
      }
    },
    onMore: function() {
      this.truncateView = false;
    },
    onLess: function() {
      this.truncateView = true;
    },
    calculateDuration: function() {
      const self = this;
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = "Present";
      } else {
        end = self.work.end_year;
      }
      return start + " - " + end;
    },
    calculateDurationInYears: function() {
      const self = this;
      let msg = "";
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = new Date().getFullYear();
      } else {
        end = self.work.end_year;
      }
      let total = end - start;
      if (total === 0) {
        msg = " (Less than a year)";
      } else if (total > 0) {
        let y = " years)";
        if (total === 1) {
          y = " year)";
        }
        msg = " (Over " + total + y;
      } else {
        msg = "Invalid";
      }
      return msg;
    }
  },

};
</script>

<style scoped>
.image-wrapper {
  text-align: left;
  margin-top: 1rem;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.image {
  width: calc(100% - 0.2rem);
  height: calc(100% - 0.2rem);
}
.single-info {
  padding: 1rem 0;
}
.info-details {
  padding: 0;
  text-align: left;
}
.univ {
  font-size: 16px;
  letter-spacing: 0;
}
.degree {
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0;
}
.score {
  color: #808080;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0;
}
</style>
